import { createAsyncThunk } from "@reduxjs/toolkit";

import { createProjectAddon as createProjectAddonRequest } from "Api/organizations/projects/createProjectAddon.request";

import type { ProjectAddonUpdateResult } from "../types";

export const createProjectAddon = createAsyncThunk<
  ProjectAddonUpdateResult,
  {
    organizationId: string;
    projectId: string;
    data: { type: string; sku: string };
  }
>(
  "app/organization/project_addons/create",
  async ({ organizationId, projectId, data }, { rejectWithValue }) => {
    try {
      const addon = await createProjectAddonRequest({
        organizationId,
        projectId,
        data
      });
      return { kind: "upsert" as const, addon };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
